const SECURITY_AREA_ID = 4;

const isSecurityExtensionHidden = props => {
  return (
    !props.abilities.canViewSecurityAnalysis ||
    (
      !props.navigableAreas
        .find(a => a.id === SECURITY_AREA_ID) ||
      !props.extensions[0] ||
      !props.extensions[0].active
    )
  );
};

const securityRoute = params => ({ isHidden: isSecurityExtensionHidden, ...params });

const routeNames = [
  'security-overview',
  'security-detail-critical-acceptable',
  'security-detail-critical-rudimentary',
  'security-detail-critical-inadequate',
  'security-detail-non-critical-acceptable',
  'security-detail-non-critical-rudimentary',
  'security-detail-non-critical-inadequate',
  'security-dashboards-overview',
  'security-dashboards-detail/:dashboardCategoryId',
  'security-dashboards-other-detail'
];

export default routeNames.map(name => securityRoute({ name }));



// WEBPACK FOOTER //
// ./src/routing/analytics/securityExtensionRoutes.js